/**
 * Rejection for a request whose outcome is unknown: it got no response at
 * all (network error, timeout, aborted) or a gateway error (502, 503, 504)
 * from nginx or the load balancer, which can arrive after the backend has
 * already done the work. A caller that must not repeat a write can check
 * whether the write happened before reporting a failure.
 */
export default class ResponseLostError extends Error {
  constructor(message?: string) {
    super(message);
    this.name = 'ResponseLostError';
  }
}

export const isResponseLostError = (err: unknown): err is ResponseLostError =>
  err instanceof ResponseLostError;
